import { OnInit, OnDestroy, Component, Output, EventEmitter, Input } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { MediaService } from '../../shared-services/media.service';
import { OverlayComponent } from '../overlay/overlay.component';

@Component({
  selector: 'app-generic-filters',
  templateUrl: './generic-filters.component.html',
  styleUrls: ['./generic-filters.component.scss'],
  animations: [
    trigger('hideAndShow', [
      state('0', style({})),
      state('1', style({})),
      transition(':enter, 0 => 1', [
        style({transform: 'translateX(-100%)'}),
        animate(250)
      ]),
      transition(':leave, 1 => 0', [
        animate(250, style({transform: 'translateX(-100%)'}))
      ]),
    ]),
  ],
})
export class GenericFiltersComponent implements OnInit, OnDestroy {

  @Input() show: boolean;
  @Output() showChange = new EventEmitter<boolean>();
  subscription: Subscription;
  isMobile: boolean;

  constructor(private mediaService: MediaService) {}

  ngOnInit() {
    this.subscription = this.mediaService.isMobile.subscribe(isMobile => this.isMobile = isMobile);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  close() {
    this.show = false;
    setTimeout(() => this.showChange.emit(false), 225);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/generic-filters/generic-filters.component.ts